import { render, staticRenderFns } from "./ContentStats.vue?vue&type=template&id=1bab516b&scoped=true&"
import script from "./ContentStats.vue?vue&type=script&lang=js&"
export * from "./ContentStats.vue?vue&type=script&lang=js&"
import style0 from "./ContentStats.vue?vue&type=style&index=0&id=1bab516b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bab516b",
  null
  
)

export default component.exports